import { prefixClassName } from "@smartrr/shared/components/primitives";
import styled from "styled-components";

export const InnerWrapper = styled.div.attrs(props => ({
  className: prefixClassName("inner"),
}))`
  & .anchor {
    display: block;
    position: relative;
    top: -250px;
    visibility: hidden;
  }
`;
